import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import { Tag } from "@msuite/ui/tag";
import { guardString } from "@msuite/utils/strings";
import type { TransferCarrierListItem } from "@msuite/utils/types";
import { NoteText } from "@/components/notes";

const columnHelper = createColumnHelper<TransferCarrierListItem>();

/**
 * A transfer carrier's columns. Four, and there is no balance among them on purpose — a trolley is
 * one individual object, so the question a load carrier's table answers ("how many are there")
 * does not apply.
 *
 * The number leads, because it is what is physically painted on the device and therefore what
 * somebody standing in the yard is matching against. The name follows as the description it is.
 */
export const columns = [
	columnHelper.accessor("number", {
		id: "number",
		header: localized("stock.transfer_carrier_no"),
		cell: (cell) => cell.getValue(),
		size: 120,
	}),
	columnHelper.accessor("name", {
		id: "name",
		header: localized("general.name"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("description", {
		id: "description",
		header: localized("general.description"),
		cell: (cell) => <NoteText note={cell.getValue()} />,
		size: 320,
	}),
	// Where it stands is the end of its last *finished* leg rather than where it is heading, so a
	// trolley in transit still reads as the zone it left — which is the honest answer to "where do
	// I go to find it".
	columnHelper.accessor("currentZoneName", {
		id: "currentZoneName",
		header: localized("stock.transfer_carrier_current_zone"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	// What is on it right now, and the figure that refuses its deletion: the foreign key cascades,
	// so removing a loaded trolley would take counted material with it.
	columnHelper.accessor("openLegCount", {
		id: "openLegCount",
		header: localized("stock.transfer_carrier_open_legs"),
		cell: (cell) => (
			<div className="w-full h-stack justify-end pr-2">
				<Tag
					direction="row-reverse"
					color={cell.getValue() > 0 ? "blue" : "gray"}
					variant="plain"
				>
					{cell.getValue()}
				</Tag>
			</div>
		),
		size: 120,
	}),
];
